import React from "react";
import styled from "styled-components";
import { Avatar, Grid } from "@mui/material";

import { Chip, ComponentHeader, TextField } from "../../../components";
import { colors, TextFourteenBlack } from "../../css components/Style";

const ImageAvatar = styled(Avatar)`
  height: 130px;
  width: 130px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
`;

export default function FormOne({ formData }) {
  return (
    <React.Fragment>
      <Grid size={12}>
        <ComponentHeader
          title={"Agency Details"}
          subtitle={""}
          buttons={[
            formData?.platformSource && (
              <Chip
                label={formData?.platformSource}
                background={colors.green}
              />
            ),
          ]}
        />
      </Grid>

      {formData?.apiPartner && (
        <Grid size={12} style={{ textAlign: "end" }}>
          <TextFourteenBlack>
            API Partner : {formData.apiPartner?.replace(/_/g, " ") || "-"}
          </TextFourteenBlack>
        </Grid>
      )}

      <Grid item textAlign="center" display="flex">
        <ImageAvatar src={formData.avatar} />
      </Grid>

      <Grid size={12}></Grid>

      <Grid size={4}>
        <TextField
          size="small"
          value={formData.agencyName}
          label="Agency Name"
          disabled
          placeholder="Agency Name"
          name="agencyName"
        />
      </Grid>

      <Grid size={4}>
        <TextField
          size="small"
          label="Website"
          disabled
          value={formData.website}
          name="website"
          placeholder="Website"
        />
      </Grid>

      <Grid size={4}>
        <TextField
          size="small"
          value={formData.about}
          label="About"
          disabled
          placeholder="About"
          name="about"
          multiline
        />
      </Grid>
    </React.Fragment>
  );
}
